import "%modules%/header/header";
import "%modules%/price/price";
import "%modules%/faq/faq";
import "%modules%/select/select";
import "%modules%/form/form";
import "%modules%/modal/modal";
import "%modules%/translate/translate";
import "%modules%/flags/flags";
